import {TableCell, TableRow, Typography} from "@material-ui/core";
import EmptyRow from "../../../../../../../../ui/tables/rows/empty-row/EmptyRow";
import {useSelector} from "react-redux";
import Button from "@material-ui/core/Button";
import {headCells} from "./PacchetiAggiuntiviHelper";
import GrayHeaderCard from "../../../../../../../../ui/cards/gray-header-card/GrayHeaderCard";
import React from "react";
import SimpleTable from "../../../../../../../../../shared/components/tables/simple-table/SimpleTable";

const PacchettiAggiuntivi = () => {
    const pacchetiData = useSelector(state => state.ordiniConsipReducer.offerteRowDetails.data.pacchettiAggiuntiviItemList);
    const loading = useSelector(state => state.ordiniConsipReducer.offerteRowDetails.loading);

    const tableRows = (
        pacchetiData && pacchetiData.length > 0 ? pacchetiData.map((row, idx) => (
            <TableRow key={`paccheti-row-${idx}`}>
                <TableCell component="th" scope="row">
                    <Typography variant="subtitle1">{row.name}</Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography variant="body2">{row.description}</Typography>
                    <Button variant={"text"} color="primary" style={{textTransform: "none"}}>
                        Vedi i dettagli
                    </Button>
                </TableCell>
            </TableRow>
        )) : <EmptyRow text='dato' colSpan={headCells.length}/>
    )

    return (
        <GrayHeaderCard title={
            <Typography variant="subtitle2">
                Pacchetti aggiuntivi
            </Typography>
        }>
            <SimpleTable headCells={headCells} tableRows={tableRows} loading={loading}/>
        </GrayHeaderCard>
    )
}

export default PacchettiAggiuntivi;